import React, { useContext } from 'react';
import { ButtonLink } from 'src/components/Button/ButtonLink';
import { BasketContext } from 'src/components/Basket/BasketContext';

import { BasketShareMachine } from '../BasketShared/BasketShareMachine';

import classes from './BasketSummary.scss';

type Props = Record<string, unknown>;

export const SummaryActions: React.FC<Props> = React.memo(() => {
    return (
        <div className={classes.summaryActions}>
            <SummaryActionsShare />
            <ButtonLink to="/checkout" width="full" className={classes.summaryAction}>
                Continue to checkout
            </ButtonLink>
        </div>
    );
});

export const SummaryActionsShare: React.FC<Props> = React.memo(() => {
    const { cartId } = useContext(BasketContext);
    if (!cartId) return null;
    return (
        <div className={classes.summaryAction}>
            <BasketShareMachine cartId={cartId} display="modal" shareButtonContent={<span>Share Basket</span>} />
        </div>
    );
});
